export const PAGES_COLLECTIONS = [
  'bmwgroup-pages',
  'bmwyuc-pages',
  'consulting-pages',
  'docs-pages',
  'mini-pages',
  'pages',
  'vwn-pages',
  'alphabet-pages',
  'status-pages',
] as const
